import React from "react";
import {Image} from 'react-bootstrap';

import "./CasePresentation.css";

import icon_case from "../../asset/images/icon_case.webp";

import img_donghai_2 from "../../asset/images/img_donghai_2.png";
import img_huanghai_2 from "../../asset/images/img_huanghai_2.png";
import img_ocean_2 from "../../asset/images/img_ocean_2.png";

import logo_food from "../../asset/images/logo_food.png";
import logo_ocean from "../../asset/images/logo_ocean.png";
import icon_comein from "../../asset/images/icon_comein.png";

// 案例展示
class CasePresentation extends React.Component {
  render() {
    return (
      <div className="case">
        <Image src={icon_case} className="case_ico" />
        <div className="case_cards">
          <div className="case_card">
            <Image src={img_donghai_2} className="case_card_img" />
            <div className="case_card_right">
              <div className="case_card_word">
                <div className="case_card_title">
                  <Image src={logo_food} className="case_card_ico" />
                  <div className="case_title_word">
                    中粮东海粮油工业有限公司
                  </div>
                </div>
                <div className="case_card_paragraph">
                  全球最大的综合粮油食品加工基地之一，占地面积1267亩，主要从事大豆、小麦、大米加工以及油脂深加工项目，拥有榨油、精炼、饲料、小包装、面粉、大米、专用油脂、大豆磷脂等多个专业生产厂。
                </div>
              </div>
              <Image src={icon_comein} className="case_card_comein" />
            </div>
          </div>
        </div>
        <div className="case_cards">
          <div className="case_card">
            <Image src={img_huanghai_2} className="case_card_img" />
            <div className="case_card_right">
              <div className="case_card_word">
                <div className="case_card_title">
                  <Image src={logo_food} className="case_card_ico" />
                  <div className="case_title_word">
                    中粮黄海粮油工业有限公司
                  </div>
                </div>
                <div className="case_card_paragraph">
                  中粮集团油脂板块重要综合性粮油加工基地，山东省粮油龙头企业，拥有直达岚山港8万吨级泊位的专用物流通道，具备油料压榨、油脂精炼、深加工等完整的油脂产业链。
                </div>
              </div>
              <Image src={icon_comein} className="case_card_comein" />
            </div>
          </div>
        </div>
        <div className="case_cards">
          <div className="case_card">
            <Image src={img_ocean_2} className="case_card_img" />
            <div className="case_card_right">
              <div className="case_card_word">
                <div className="case_card_title">
                  <Image src={logo_ocean} className="case_card_ico" />
                  <div className="case_title_word">
                    扬州中远海运重工有限公司
                  </div>
                </div>
                <div className="case_card_paragraph">
                  中国远洋海运集团有限公司旗下的装备制造产业集群，以船舶和海洋工程装备建造、修理改装及配套服务为一体的大型重工企业。主要从事中大型船舶、水上浮动装置和海洋工程装备制造等。
                </div>
              </div>
              <Image src={icon_comein} className="case_card_comein" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CasePresentation
